module.exports = __webpack_public_path__ + "static/media/Dog.5e3ddb0c.png";